import { ReactElement, useRef } from 'react';
import A11yDialogInstance from 'a11y-dialog';

import './RemoveStayAlertModal.scss';
import { translate, getUniqueId } from '@micro-apps/env';
import Icon from '../../../Icon';
import Dialog from '../../../Dialog/Dialog';
import Cta from '../../../Cta';

interface Props {
	title: string;
	content: string;
	confirmLabel?: string | null;
	cancelLabel?: string | null;
	dialogRef?: (instance: A11yDialogInstance) => void;
	onConfirm: () => void;
	onHide?: () => void;
}

export default function RemoveStayAlertModal({
	title,
	content,
	confirmLabel,
	cancelLabel,
	dialogRef = () => undefined,
	onConfirm,
	onHide = () => undefined,
}: Props): ReactElement {
	const dialog = useRef<A11yDialogInstance>(undefined);

	const handleCancel = () => {
		dialog.current?.hide();
	};

	const handleConfirm = () => {
		onConfirm();
		dialog.current?.hide();
	};

	return (
		<Dialog
			id={`removeStayAlert-dialog-${getUniqueId()}`}
			onHide={onHide}
			dialogRef={instance => {
				dialog.current = instance;
				dialogRef(instance);
			}}
			disableScroll
			classNames={{
				container: 'Dialog hidden RemoveStayAlertModal',
				overlay: 'Dialog-overlay',
				dialog: 'Dialog-wrapper RemoveStayAlert-Dialog',
				title: 'Dialog-title',
				closeButton: 'Dialog-closebutton',
			}}
		>
			<div className="removeStayAlert-wrapper">
				<Icon icon="shopping_cart" />
				<div className="removeStayAlert-text-1 ty-h3">{title}</div>
				<div className="removeStayAlert-text-2 ty-b2">{content}</div>
				<div className="Dialog-Buttons">
					<Cta onClick={handleCancel} type="secondary">
						{cancelLabel || translate('Cancel')}
					</Cta>
					<Cta onClick={handleConfirm} type="primary">
						{confirmLabel || translate('Continue')}
					</Cta>
				</div>
			</div>
		</Dialog>
	);
}
